import { withFormField } from "@fas/ui-core";
import type { JSX } from "react";

type Props = {
  value?: string;
  compare?: (arg0: any) => boolean;
  children: JSX.Element | JSX.Element[];
};

function ShowByValue({
  compare = (v: any): boolean => Boolean(v),
  children,
  value = "",
}: Props) {
  if (compare(value)) {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {children}
      </>
    );
  }

  return null;
}

export default withFormField(ShowByValue);
